"use client";

import type React from "react";
import { NFTCard, PageWrapper } from "@/components/core";

export const FastCheckoutProjectSkeleton: React.FC = () => {
  return (
    <PageWrapper
      className="relative w-full"
      outsideChildren={
        <div className="relative w-full h-[300px] md:h-[400px] lg:h-[500px]">
          {/* Banner skeleton */}
          <div className="absolute inset-0 bg-text-disabled/20 animate-pulse" />
          <div className="absolute inset-0 bg-linear-to-t from-bg-primary via-bg-primary/70 to-transparent z-0" />
          <div className="absolute inset-0 flex items-end p-4">
            {/* Profile & Social skeleton */}
            <div className="flex items-center justify-end space-x-4 text-text-primary mb-4 w-full">
              <div className="flex justify-between items-end w-full">
                <div className="flex gap-3">
                  {/* Avatar skeleton */}
                  <div className="size-14 bg-text-disabled/20 rounded-sm animate-pulse" />
                  <div className="flex flex-col gap-2">
                    {/* Project name skeleton */}
                    <div className="h-5 bg-text-disabled/20 rounded-sm w-32 animate-pulse" />
                    {/* Social icons skeleton */}
                    <div className="flex items-center gap-2">
                      <div className="w-[22px] h-[22px] bg-text-disabled/20 rounded animate-pulse" />
                      <div className="w-[22px] h-[22px] bg-text-disabled/20 rounded animate-pulse" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    >
      <div className="text-text-primary mb-4">
        <div className="py-4">
          {/* Title skeleton */}
          <div className="h-6 bg-text-disabled/20 rounded-sm w-32 mb-2 animate-pulse" />
          {/* Description skeleton */}
          <div className="h-4 bg-text-disabled/20 rounded-sm w-full max-w-md animate-pulse" />
        </div>
        <div className="flex flex-col sm:flex-row gap-2 py-4 w-full justify-between">
          {/* Label skeleton */}
          <div className="h-4 bg-text-disabled/20 rounded-sm w-20 shrink-0 animate-pulse" />
          {/* Type selection buttons skeleton */}
          <div className="flex gap-2">
            {Array.from({ length: 5 }, (_, index) => index + 1).map((num) => (
              <div
                key={num}
                className="h-8 bg-text-disabled/20 rounded-sm w-16 animate-pulse"
              />
            ))}
          </div>
        </div>
      </div>
      {/* NFTCard skeleton */}
      <NFTCard loading={true} nftMarketAddress="" nftCollectionAddress="" />
    </PageWrapper>
  );
};
